import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Компонент для автоматической прокрутки страницы наверх при изменении маршрута
 */
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    // Прокручиваем страницу наверх при изменении маршрута
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Мгновенная прокрутка без анимации
    })
  }, [pathname])

  return null
}

export default ScrollToTop
